export interface AddDocumentFormModel {
  title?: string;
  description?: string;
  expirationDate?: string;
  file?: File;
}
